import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { Hotkey } from 'ui-components/components/hotkey';

export const messages = defineMessages({
  name: {
    description: 'Go to the next record in the Orders grid',
    defaultMessage: 'Go to Next Order',
    id: 'qd8j4I',
  },
});

export const hotkey = ['DownArrow'];
export const barcodeContent = '+67PN3AYR75ZM=';

const GoToNextRecordHotkey = ({ children = null, actionHandler }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: hotkey,
      hotkey,
      handler: actionHandler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: false,
    }),
    [intl, actionHandler],
  );

  return <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>;
};

GoToNextRecordHotkey.propTypes = {
  children: PropTypes.node,
  actionHandler: PropTypes.func.isRequired,
};

export default GoToNextRecordHotkey;
